import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../../config/authAxios";
import apiRoutes from "../../apiConfigs";

export const addExternalLinkApi = createAsyncThunk(
  "auth/teacher-lounge/addExternalLink",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.post(
        apiRoutes.adminAction(`events/external-links`, 1),
        data
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const addExternalLinkSlice = createSlice({
  name: "addExternalLink",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(addExternalLinkApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addExternalLinkApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(addExternalLinkApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const addExternalLinkReducer = addExternalLinkSlice.reducer;
